<template>
    <div>
      <transition name="fold">
        <div class="areaBox" v-show="show">
         <div>
           <div style="text-align: center;font-weight: 800;font-size: 18px">{{areaDistrict}} -- <span style="font-size: 14px;color: #6f7180;font-weight: normal">{{info.areaName}} —— {{(dis.distance/1000).toFixed(2)}}公里 —— 大概需要{{(dis.duration/3600).toFixed(2)}}小时</span></div>
         </div>
          <el-tabs tab-position="left" style="height: 94%;" id="areaTables">
            <el-tab-pane label="地点分析">
              <div :style="{height: contentHeight}" >
                <div style="margin-bottom: 10px">
                  <div class="outline" >
                    <div class="common-filter">
                      <div class="shared-common-filter-first-row">
                        <div class="date-picker">
                          <div class="date-picker-displayText" style="width: 100%;font-size: 14px">
                            <div class="date-picker-displayMainText">
                              <span style="margin-right: 20px">
                                <span>统计周期：</span>
                                <span style="color: #9a9a9a;font-weight: 400;">{{new Date(cycle.startDate).format("yyyy-MM-dd")}} 至 {{new Date(cycle.endDate).format("yyyy-MM-dd")}}</span>
                              </span>
                              <span>
                                <span>对比维度：</span>
                                <span style="color: #9a9a9a;font-weight: 400;">{{dateRange[current].range}}</span>
                              </span>
                            </div>
                            <div class="date-picker-shortcutSwitch">
                              <span class="date-picker-short-item" :class="{current:index == current}" v-for="(item,index) in dateRange" :key="index" @click="findRecently(index,item.day)">{{item.title}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-top: 10px;"><marquee onmouseover=this.stop() onmouseout=this.start()><span style="color: rgb(255, 112, 0)">运费按发货区域匹配，如果地点出现错误，可能存在历史发货地点填写错误，请核实发货地点！详情查看历史数据！</span></marquee></div>
                    </div>
                  </div>
                </div>
                <div class="oui-card" v-if="analysis.flag" v-loading="analysisLoading">
                  <div class="oui-card-header-wrapper">
                    <h4 class="oui-card-title">找车参考(已排除自己上车)&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size: 14px;color: #6f7180;font-weight: normal">司机报价范围：{{analysis.freightMinByDriver}}元/吨~{{analysis.freightMaxByDriver}}元/吨 </span></h4>
                    <div class="cardHeader"></div>
                  </div>
                  <div class="oui-card-content clearF">
                    <div>
                      <div class="index-container">
                        <div class="index-content-container">
                          <div class="index-item-selectable">
                            <div class="oui-indexCell" style="padding: 0px;">
                              <div class="oui-indexCell-indexName">可收垫款率</div>
                              <div class="oui-indexCell-indexValue">{{analysis.advancesRate}}%</div>
                              <div class="oui-indexCell-indexChange">
                                <el-popover
                                  :open-delay=400
                                  placement="left"
                                  trigger="click" >
                                  <div>
                                    <ul class="basic-list" v-if="analysis.advancesMonth != null">
                                      <li :key="item" v-for="item in analysis.advancesMonth.split(',')">{{item}}</li>
                                    </ul>
                                  </div>
                                  <p slot="reference" v-if="analysis.advancesMonth != null && analysis.advancesMonth.split(',').length >1">历史垫款月份：{{analysis.advancesMonth.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
                                  <p slot="reference" v-else>历史垫款月份：{{analysis.advancesMonth}}</p>
                                </el-popover>
                              </div>
                            </div>
                          </div>
                          <div class="index-item-selectable">
                            <div class="oui-indexCell" style="padding: 0px;">
                              <div class="oui-indexCell-indexName">发货总次数</div>
                              <div class="oui-indexCell-indexValue">{{analysis.total}}次</div>
                              <!--<div class="oui-indexCell-indexChange">上次发货时间：2018-10-12</div>-->
                            </div>
                          </div>
                          <div class="index-item-selectable">
                            <div class="oui-indexCell" style="padding: 0px;">
                              <div class="oui-indexCell-indexName">历史<span style="color:red;">最高</span>运费</div>
                              <div class="oui-indexCell-indexValue">{{analysis.freightMax}}元/吨 <span style="font-size: 14px;color: #6f7180">{{analysis.areaMax}}</span></div>
                              <div class="oui-indexCell-indexChange">时间：{{new Date(analysis.createDateMax).format("yyyy-MM-dd") +' '+analysis.supplyNameMax}}</div>
                            </div>
                          </div>
                          <div class="index-item-selectable">
                            <div class="oui-indexCell" style="padding: 0px;">
                              <div class="oui-indexCell-indexName">历史<span style="color:green;">最低</span>运费</div>
                              <div class="oui-indexCell-indexValue">{{analysis.freightMin}}元/吨 <span style="font-size: 14px;color: #6f7180">{{analysis.areaMin}}</span></div>
                              <div class="oui-indexCell-indexChange">时间：{{new Date(analysis.createDateMin).format("yyyy-MM-dd") +' '+analysis.supplyNameMin}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div><h3 style="text-align: center">找车提示：请根据当日运力情况适当调整运费！回程车优先、销售额高者优先、运费便宜优先、交易靠前优先！</h3></div>
                </div>
                <div v-else  v-loading="analysisLoading"><h2 style="text-align: center;line-height: 150px">不好意思！该时间没有找到发货数据!</h2></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="历史数据" :lazy="false" style="height: 100%">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-date-picker
                    v-model="dateTime"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始月"
                    end-placeholder="结束月"
                    :picker-options="pickerOptions"
                    @change="changeDate">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-if="show" multiple collapse-tags v-model="info.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">
                    <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
                    </el-option>
                  </el-select>
                  <el-select v-model="info.supplyId" clearable style="width: 90px;margin-right: 5px"  placeholder="经理">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in appInfo.supplyList" :key="item.supplyId" :label="item.name" :value="item.supplyId">
                    </el-option>
                  </el-select>
                  <el-select multiple collapse-tags v-model="info.areaNameList" clearable style="margin-right: 5px"  placeholder="地区">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in areaNames" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                  <el-select multiple remote filterable
                             v-model="info.carId" clearable
                             class="selectSearch"
                             style="width: 350px;margin-right: 5px"
                             placeholder="输入车牌号，查询排名"
                             :remote-method="remoteMethod"
                             :loading="remoteLoading">
                    <el-option v-for="item in carList" :key="item.carId" :label="item.count>0 ? item.carNumber + '--自己上车'+item.count+'次' : item.carNumber" :value="item.carId" :class="item.count>0 ? 'blacklist' : ''">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
              </el-form>
                <div :style="{height: contentHeight}">
                  <el-table
                    v-loading="loading"
                    :data="orderByAreaPage.records"
                    :row-class-name="blacklist"
                    @sort-change="orderTon"
                    stripe
                    height="100%"
                    style="width: 100%;height:100%;overflow: auto;z-index: 1;font-size: 12px">
                    <el-table-column
                      label="日期"
                      label-class-name="header">
                      <template slot-scope="scope">
                        <span>{{new Date(scope.row.createDate).format("yyyy-MM-dd")}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="areaName"
                      label="地点"
                      label-class-name="header">
                    </el-table-column>
                    <el-table-column
                      label="车主"
                      label-class-name="header">
                      <template slot-scope="scope">
                        <p>{{scope.row.driverName}}</p>
                        <p>{{scope.row.driverAddress}}</p>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="phone"
                      label="电话"
                      label-class-name="header">
                    </el-table-column>
                    <el-table-column
                      prop="carNumber"
                      label="车牌"
                      label-class-name="header">
                    </el-table-column>
                    <el-table-column
                      label="吨位"
                      prop="r.tonnage"
                      sortable="custom"
                      label-class-name="header">
                      <template slot-scope="scope">
                        <span>{{scope.row.tonnage}}吨</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="实际运费"
                      label-class-name="header">
                      <template slot-scope="scope">
                        <span>{{scope.row.actualFreight+scope.row.priceUnit}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="订车运费"
                      label-class-name="header">
                      <template slot-scope="scope">
                        <span>{{scope.row.freight+scope.row.priceUnit}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="实际收款"
                      label-class-name="header">
                      <template slot-scope="scope">
                        <span>{{scope.row.total}}元</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="supplyName"
                      label="订车经理"
                      label-class-name="header">
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      label="找车人"
                      label-class-name="header">
                    </el-table-column>
                  </el-table>
                </div>
                <div style="margin-top: 4px">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="orderByAreaPage.current"
                    :page-sizes="[15, 30, 50, 100]"
                    :page-size="orderByAreaPage.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="orderByAreaPage.total">
                  </el-pagination>
                </div>
            </el-tab-pane>
            <el-tab-pane label="拉货排行" :lazy="false">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-date-picker
                    v-model="dateTime"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始月"
                    end-placeholder="结束月"
                    :picker-options="pickerOptions"
                    @change="changeDate">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-if="show" multiple collapse-tags v-model="info.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">
                    <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
                    </el-option>
                  </el-select>
                  <el-select v-model="info.supplyId" clearable style="width: 90px;margin-right: 5px"  placeholder="经理">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in appInfo.supplyList" :key="item.supplyId" :label="item.name" :value="item.supplyId">
                    </el-option>
                  </el-select>
                  <el-select multiple collapse-tags v-model="info.areaNameList" clearable style="margin-right: 5px"  placeholder="地区">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in areaNames" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                  <el-select multiple remote filterable
                             v-model="info.carId" clearable
                             class="selectSearch"
                             style="width: 350px;margin-right: 5px"
                             placeholder="输入车牌号，查询排名"
                             :remote-method="remoteMethod"
                             :loading="remoteLoading">
                    <el-option v-for="item in carList" :key="item.carId" :label="item.count>0 ? item.carNumber + '--自己上车'+item.count+'次' : item.carNumber" :value="item.carId" :class="item.count>0 ? 'blacklist' : ''">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
              </el-form>
              <div :style="{height: contentHeight}">
                <el-table
                  v-loading="loading"
                  :data="driverList.records"
                  :row-class-name="blackList"
                  stripe
                  height="100%"
                  style="width: 100%;height:100%;overflow: auto;z-index: 1;font-size: 12px">
                  <el-table-column
                    prop="rank"
                    label="排名"
                    align="center"
                    width="80"
                    label-class-name="header">
                  </el-table-column>
                  <el-table-column
                    label="姓名"
                    label-class-name="header">
                    <template slot-scope="scope">
                      <el-popover
                        :open-delay=400
                        placement="left"
                        trigger="click" >
                        <div>
                          <ul class="basic-list">
                            <li :key="item" v-for="item in scope.row.driverName.split(',')">{{item}}</li>
                          </ul>
                        </div>
                        <p slot="reference" v-if="scope.row.driverName.split(',').length >1">{{scope.row.driverName.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
                        <p slot="reference" v-else>{{scope.row.driverName.split(',')[0]}}</p>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="电话"
                    label-class-name="header">
                    <template slot-scope="scope">
                      <el-popover
                        :open-delay=400
                        placement="left"
                        trigger="click" >
                        <div>
                          <ul class="basic-list">
                            <li :key="item" v-for="item in scope.row.phone.split(',')">{{item}}</li>
                          </ul>
                        </div>
                        <p slot="reference" v-if="scope.row.phone.split(',').length >1">{{scope.row.phone.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
                        <p slot="reference" v-else>{{scope.row.phone.split(',')[0]}}</p>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="carNumber"
                    label="车牌"
                    label-class-name="header">
                  </el-table-column>
                  <el-table-column
                    label="地址"
                    label-class-name="header">
                    <template slot-scope="scope">
                      <el-popover
                        :open-delay=400
                        placement="left"
                        trigger="click" >
                        <div>
                          <ul class="basic-list" v-if="scope.row.address != null">
                            <li :key="item" v-for="item in scope.row.address.split(',')">{{item}}</li>
                          </ul>
                        </div>
                        <p slot="reference" v-if="scope.row.address != null && scope.row.address.split(',').length >1">{{scope.row.address.split(',')[0]}} <i style="font-size: 10px;color: #00a0dc;cursor: pointer">更多>></i></p>
                        <p slot="reference" v-else>{{scope.row.address}}</p>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="总吨位"
                    label-class-name="header">
                    <template slot-scope="scope">
                      <span>{{scope.row.tonnage}}吨</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="total"
                    label="总额"
                    label-class-name="header">
                    <template slot-scope="scope">
                      <p>{{ scope.row.total }}元</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="total"
                    label="总拉货数"
                    label-class-name="header">
                    <template slot-scope="scope">
                      <p>{{ scope.row.count }}趟</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-top: 4px">
                <el-pagination
                  background
                  @size-change="driverOrderSizeChange"
                  @current-change="driverOrderCurrentChange"
                  :current-page="driverList.current"
                  :page-sizes="[15, 30, 50, 100]"
                  :page-size="driverList.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="driverList.total">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="经理排行" >
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-date-picker
                    v-model="dateTime"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始月"
                    end-placeholder="结束月"
                    :picker-options="pickerOptions"
                    @change="changeDate">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-if="show" multiple collapse-tags v-model="info.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">
                    <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
                    </el-option>
                  </el-select>
                  <el-select v-model="info.supplyId" clearable style="width: 90px;margin-right: 5px"  placeholder="经理">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in appInfo.supplyList" :key="item.supplyId" :label="item.name" :value="item.supplyId">
                    </el-option>
                  </el-select>
                  <el-select multiple collapse-tags v-model="info.areaNameList" clearable style="margin-right: 5px"  placeholder="地区">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in areaNames" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                  <el-select multiple remote filterable
                             v-model="info.carId" clearable
                             class="selectSearch"
                             style="width: 350px;margin-right: 5px"
                             placeholder="输入车牌号，查询排名"
                             :remote-method="remoteMethod"
                             :loading="remoteLoading">
                    <el-option v-for="item in carList" :key="item.carId" :label="item.count>0 ? item.carNumber + '--自己上车'+item.count+'次' : item.carNumber" :value="item.carId" :class="item.count>0 ? 'blacklist' : ''">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
              </el-form>
              <supplyCharts :searchData="info" :slider="show" ref="mychild"/>
            </el-tab-pane>
            <el-tab-pane label="发货列表" >
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-date-picker
                    v-model="dateTime"
                    type="monthrange"
                    align="right"
                    unlink-panels
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始月"
                    end-placeholder="结束月"
                    :picker-options="pickerOptions"
                    @change="changeDate">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-if="show" multiple collapse-tags v-model="info.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">
                    <el-option v-for="item in appInfo.appCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId">
                    </el-option>
                  </el-select>
                  <el-select v-model="info.supplyId" clearable style="width: 90px;margin-right: 5px"  placeholder="经理">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in appInfo.supplyList" :key="item.supplyId" :label="item.name" :value="item.supplyId">
                    </el-option>
                  </el-select>
                  <el-select multiple collapse-tags v-model="info.areaNameList" clearable style="margin-right: 5px"  placeholder="地区">
                    <el-option label="全部" value="">
                    </el-option>
                    <el-option v-for="item in areaNames" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                  <el-select multiple remote filterable
                             v-model="info.carId" clearable
                             class="selectSearch"
                             style="width: 350px;margin-right: 5px"
                             placeholder="输入车牌号，查询排名"
                             :remote-method="remoteMethod"
                             :loading="remoteLoading">
                    <el-option v-for="item in carList" :key="item.carId" :label="item.count>0 ? item.carNumber + '--自己上车'+item.count+'次' : item.carNumber" :value="item.carId" :class="item.count>0 ? 'blacklist' : ''">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
              </el-form>
              <areaCharts :searchData="info" :slider="show" ref="mychild"/>
            </el-tab-pane>
          </el-tabs>
         </div>
      </transition>
      <transition name="fade">
        <div class="list-mask" @click="hideList('1')" v-show="show"></div>
      </transition>
    </div>
</template>

<script>
import { selectOrderByArea, driverOrderBySale, selectAnalysisByArea } from '../api/ordersStatistics'
import { getCarForNumber } from '../api/car'
import pcaa from 'assets/js/pcaa'
import supplyCharts from '@/components/supplyCharts'
import areaCharts from '@/components/areaCharts'
import AMap from 'AMap'
import axios from 'axios'
var instance = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export default {
  name: 'orderByArea',
  props: {
    slider: {
      type: Boolean,
      default: false
    },
    areaInfo: {
      default: {}
    }
  },
  data () {
    return {
      dateRange: [
        {
          title: '近7天',
          day: 7,
          range: '近一周'
        },
        {
          title: '近30天',
          day: 30,
          range: '近一个月'
        },
        {
          title: '近60天',
          day: 60,
          range: '近两个月'
        },
        {
          title: '全年',
          day: 365,
          range: '近一年'
        }
      ],
      dateTime: [],
      analysisLoading: false,
      loading: false,
      show: false,
      appInfo: {},
      areaNames: null,
      areaDistrict: '',
      orderByAreaPage: {},
      dis: {
        distance: 0,
        duration: 0
      },
      info: {
        appId: null,
        supplyId: null,
        categoryId: [],
        areaName: null,
        areaCode: null,
        carId: [],
        areaNameList: [],
        current: 1,
        pageSize: 15,
        orderCurrent: 1,
        orderPageSize: 15,
        startDate: '',
        isAsc: false,
        orderField: null,
        endDate: ''
      },
      cycle: {
        startDate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
        endDate: new Date()
      },
      carList: [],
      driverList: [],
      remoteLoading: false,
      contentHeight: '',
      current: 1,
      analysis: {
        advancesMax: null,
        advancesRate: null,
        createDateMax: null,
        createDateMin: null,
        flag: false,
        freightMax: null,
        freightMaxByDriver: null,
        freightMin: null,
        freightMinByDriver: null,
        supplyNameMax: null,
        supplyNameMin: null,
        advancesMonth: null,
        areaMax: null,
        areaMin: null,
        total: null
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    slider (val) {
      this.show = val
      if (!val) {
        this.info.categoryId = []
      } else {
        this.findRecently(1, 30)
      }
    },
    areaInfo: {
      handler: function (val) {
        this.dis = {
          distance: 0,
          duration: 0
        }
        this.info.appId = val.appId
        this.info.supplyId = val.supplyId
        if (!this.wei.isNull(val.categoryId)) {
          this.info.categoryId[0] = val.categoryId
        } else {
          this.info.categoryId = []
        }
        this.info.areaName = val.areaName
        this.info.areaCode = val.areaCode
        this.info.areaNameList = []
        this.info.carId = []
        this.info.current = 1
        this.info.pageSize = 15
        this.info.orderCurrent = 1
        this.info.orderPageSize = 15
        this.getOrderAreaList(this.info)
        this.driverOrderSearch(this.info)
        this.$nextTick(() => {
          this.contentHeight = (document.getElementById('areaTables').offsetHeight - 85) + 'px'
        })
      }
    }
  },
  created () {

  },
  methods: {
    _getDis ({areaName, areaCode}) {
      let _this = this
      let destination
      let url = '//restapi.amap.com/v3/geocode/geo?address=' + _this.areaDistrict + _this.info.areaName + 'city=' + areaCode + '&key=69674879fdcf0d22a67deda555e2ef3b'
      instance.get(url).then((data) => {
        if (data.data.geocodes.length > 0) {
          destination = data.data.geocodes[0].location
          let map = new AMap.Map('container', {})
          let geolocation
          map.plugin('AMap.Geolocation', function () {
            geolocation = new AMap.Geolocation({
              enableHighAccuracy: true,
              timeout: 10000
            })
            map.addControl(geolocation)
            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', complete)
          })
        }
      })
      function complete (data) {
        let origins = data.position
        let url = '//restapi.amap.com/v3/distance?origins=' + origins.lng + ',' + origins.lat + '&destination=' + destination + '&key=69674879fdcf0d22a67deda555e2ef3b'
        instance.get(url).then((data) => {
          if (data.data.results.length > 0) {
            _this.dis = data.data.results[0]
            console.log(data.data.results[0])
          }
        })
      }
    },
    changeDate (item) {
      if (item !== null) {
        this.info.startDate = item[0]
        this.info.endDate = item[1]
      } else {
        this.info.startDate = null
        this.info.endDate = null
      }
    },
    findRecently (index, number) {
      let _this = this
      var timer
      clearTimeout(timer)
      this.analysisLoading = true
      this.current = index
      const date = new Date()
      this.cycle = Object.assign({}, this.info)
      this.cycle.startDate = new Date(date.getTime() - 3600 * 1000 * 24 * number)
      this.cycle.endDate = new Date()
      this.cycle.areaCode = _this.areaInfo.areaCode
      this.cycle.areaName = _this.areaInfo.areaName
      this.cycle.appId = _this.areaInfo.appId
      timer = setTimeout(() => {
        selectAnalysisByArea(this.cycle).then((response) => {
          _this.analysisLoading = false
          _this.analysis = response.data.data
          _this._getDis(_this.areaInfo)
        }).catch(() => {
          _this.analysisLoading = false
        })
      }, 1000)
    },
    getOrderAreaList (data) {
      let _this = this
      // let url = `https://restapi.amap.com/v3/assistant/inputtips?key=69674879fdcf0d22a67deda555e2ef3b&keywords=${this.info.areaName}&city=${this.info.areaCode};`
      // this.$jsonp(url).then(json => {
      //   if (json.tips.length > 0) {
      //     _this.areaDistrict = json.tips[0].district
      //   }
      // })
      let adcode = this.info.areaCode.toString()
      if (adcode % 10000 === 0) {
        let str = pcaa['86'][adcode]
        _this.areaDistrict = str.toString().replace('-市辖区', '').replace('省-', '-').replace('市-', '-')
      } else {
        var province = adcode.substring(0, 2) + '0000'
        var city = adcode.substring(0, 4) + '00'

        if (adcode % 100 === 0) {
          let str = pcaa['86'][province] + '-' + pcaa[province][adcode]
          _this.areaDistrict = str.toString().replace('-市辖区', '').replace('省-', '-').replace('市-', '-')
        } else {
          let str = pcaa['86'][province] + '-' + (pcaa[province][city] || pcaa[province][adcode]) + '-' + (pcaa[city] && pcaa[city][adcode])
          _this.areaDistrict = str.toString().replace('-市辖区', '').replace('省-', '-').replace('市-', '-').replace('-undefined', '')
        }
      }
      this.loading = true
      setTimeout(() => {
        selectOrderByArea(data).then((response) => {
          _this.appInfo = response.data.data.appInfoVo
          _this.areaNames = response.data.data.areaNames
          _this.orderByAreaPage = response.data.data.orderByAreaPage
          this.loading = false
        })
      }, 600)
    },
    handleSizeChange (val) {
      this.info.pageSize = val
      this.searchOrderAreaList()
    },
    handleCurrentChange (val) {
      this.info.current = val
      this.getOrderAreaList(this.info)
    },
    searchOrderAreaList () {
      this.info.current = 1
      this.getOrderAreaList(this.info)
    },
    search () {
      this.$refs.mychild.init()
      this.searchOrderAreaList()
      this.driverOrderSearch()
    },
    driverOrderSizeChange (val) {
      this.info.orderPageSize = val
      this.getDriverOrderList()
    },
    driverOrderCurrentChange (val) {
      this.info.orderCurrent = val
      this.getDriverOrderList()
    },
    getDriverOrderList () {
      this.loading = true
      let _this = this
      driverOrderBySale(this.info).then((response) => {
        _this.driverList = response.data.data
        setTimeout(() => {
          _this.loading = false
        }, 1000)
      }).catch(() => {
        _this.loading = true
      })
    },
    driverOrderSearch () {
      this.info.orderCurrent = 1
      this.getDriverOrderList()
    },
    remoteMethod (query) {
      let _this = this
      if (query !== '') {
        let timer
        clearTimeout(timer)
        this.loading = true
        timer = setTimeout(() => {
          this.loading = false
          getCarForNumber(query, _this.areaInfo.appId).then((response) => {
            if (response.data.data.records.length > 0) {
              let map = new Map()
              let arr = []
              response.data.data.records.forEach((element) => {
                map.set(element.carId, {carNum: element.carNumber, count: element.count})
              })
              map.forEach((value, key) => {
                arr.push({carId: key, carNumber: value.carNum, count: value.count})
              })
              _this.carList = arr
            } else {
              _this.carList = []
            }
          })
        }, 200)
      } else {
        this.carList = []
      }
    },
    blackList ({row}) {
      if (row.selfCount > 3) {
        return 'blackListPush'
      } else if (row.selfCount > 0) {
        return 'blackList'
      }
      return ''
    },
    blacklist ({row}) {
      if (row.count > 3) {
        return 'blackListPush'
      } else if (row.count > 0) {
        return 'blackList'
      }
      return ''
    },
    orderTon ({prop, order}) {
      if (prop != null) {
        this.info.isAsc = (order.indexOf('asc') > -1)
        this.info.orderField = prop
      } else {
        this.info.isAsc = false
        this.info.orderField = null
      }
      this.search()
    },
    hideList (receiptId) {
      this.show = false
      this.$emit('hiden', receiptId)
    }
  },
  components: {
    supplyCharts,
    areaCharts
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .selectSearch
    .el-select__tags
      input
        border none !important
  .el-input__inner
    height 28px !important
  .blacklist
    color #d53131
    font-style italic
  .blackList
    color #e86a6a
  .blackListPush
    color red
  .outline
    max-height 90px
    background-color: #fff
    padding 12px 30px
    z-index 1000
    color: #333
    transition height .3s ease-out
    .shared-common-filter-first-row
      display flex
      .date-picker
        flex 1
        position: relative
        padding: 0!important
        display: block!important
        .date-picker-displayText
          &:before
            content: " "
            display: table
          .date-picker-displayMainText
            float: left
            height: 32px
            line-height: 32px
          .date-picker-shortcutSwitch
            float right
            &:after
              content: " "
              display: table
              clear: both
            .date-picker-short-item
              position: relative
              display: inline-block
              padding: 0 10px
              height: 32px
              line-height: 32px
              margin-left: 10px
              cursor pointer
              &:before
                position: absolute
                top: 0
                left: 0
                content: " "
                width: 100%
                height: 100%
                border: 1px solid #e3e3e3
              &:hover
                box-shadow: 0 4px 4px 0 rgba(20,93,167,.17)
            .current
              &:before
                border: 2px solid #007fff;
  .oui-card
    background: #fff
    margin-bottom: 10px
    box-shadow: 0 1px 3px rgba(0,0,0,.1)
    .oui-card-header-wrapper
      position: relative
      border-bottom: 1px solid #f0f0f0
      padding: 0 30px
      line-height: 50px
      &:before
        content: " "
        display: table
      .oui-card-title
        float: left
        font-size: 16px
        color: #333
        margin: 0
        font-weight: 700
      .cardHeader
        &:before
          content: " "
          display: table
        &:after
          clear: both
          content: " "
          display: table
    .oui-card-content
      position: relative
      width: 100%
      padding: 0 30px 30px
      min-height: 100px
      .index-container
        display: flex
        margin-bottom: 15px
        position: relative
        .index-content-container
          flex-grow: 1
          display: flex
          .index-item-selectable
            position: relative
            padding: 20px
            flex-grow: 1
            cursor: pointer
            &:before
              content: " "
              position: absolute
              top: 20px
              right: 0
              width: 0
              border-right: 1px solid #dbe5ed
              height: calc(100% - 40px)
              z-index: 3
            &:last-child
              &:before
               border-right: transparent
            &:hover
              box-shadow: 0 4px 4px 0 rgba(20,93,167,.17)
            .oui-indexCell
              line-height normal
              float left
              .oui-indexCell-indexName
                color: #333
                font-size: 14px
                display: inline-block
              .oui-indexCell-indexValue
                line-height: 24px
                margin-top: 8px
                color: #333
                font-size: 24px
                margin-bottom: 11px
              .oui-indexCell-indexChange
                color: #999
                font-size: 12px
  .areaBox
    position absolute
    right 0
    top -70px
    z-index 50
    width 100%
    height 75%
    background #fff
    transform: translate3d(0, 0, 0)
    padding 10px
    &.fold-enter-active, &.fold-leave-active
      transition: all 0.3s
    &.fold-enter, &.fold-leave-active
      transform: translate3d(0, -75%, 0)
  .list-mask
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 40
    backdrop-filter: blur(3px)
    opacity: 1
    background: rgba(7, 17, 27, 0.7)
    &.fade-enter-active, &.fade-leave-active
      transition: background  0.8s
    &.fade-enter, &.fade-leave-active
      opacity: 0
      background: rgba(7, 17, 27, 0)
  .clearF
    &:before
      content: " "
      display: table
    &:after
      content: " "
      display: table
      clear: both
</style>
